<template>
  <div class="container tip-container" v-show="formItem.title">{{formItem.title}}</div>
</template>
<script>
export default {
  props: ["formItem", "idx"]
};
</script>
<style lang="scss" scoped>
.container{
  display: flex;
  align-items: center;
  min-height: 0.8rem;
  font-size: 0.32rem;
  color: #fff;
  background: #ffa91c;
}
</style>

